import React, { useEffect, useRef, useState } from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import Loader from '@components/loader/1'
import Slider from 'react-slick'
import { useLocation } from '@reach/router'
import $ from 'jquery'
import { getActionByType, getCodeFromType, getQueryEventTracker } from '@helpers/helper.actions'
import { informCustomEvent } from '@helpers/helper.analytics'
import { useGetPushQuery } from '@apis/mediacore/push'
import { Action, RealEstateDataPageComponentData } from 'types'
import { Col, Container, Row } from 'react-bootstrap'
import { useCreateApplicationMutation as useSendTrackerEvent } from '@apis/mediacore/tracker'
import { ElementHTML } from '@helpers/helper.rendering'
import Image from '@components/Image'

const isBrowser = typeof window !== 'undefined'

const Hero_2 = ({
  items,
  image_gatsby,
  searcher: searcherId,
  opacityValue,
  titleElement,
  titleHexa,
  global_data,
  button,
  title,
  height,
  image,
  customFontSize,
  paragraph,
}: RealEstateDataPageComponentData) => {
  const sliderRefPush = useRef<any>()
  const sliderRefHero = useRef<any>()
  const { pathname } = useLocation()
  const currentPage = global_data.content.pages?.find(
    (page) =>
      pathname.replaceAll('/', '') === page.path.replaceAll('/', '') ||
      (process.env.GATSBY_IS_SITE_COMPILER === 'true' &&
        pathname.replace(global_data.divisionPath!, '').replaceAll('/', '') ===
          page.path.replaceAll('/', '')) ||
      (pathname.includes('/emprendimiento/') && page.path === '/desarrollo_detalle') ||
      (pathname.includes('/propiedad/') && page.path === '/propiedad_detalle') ||
      (pathname.includes('/novedad/') && page.path === '/novedad_detalle'),
  )

  const { data: allPushData, isLoading: loading } = useGetPushQuery({
    page: currentPage?.id,
    data_id: '',
  })

  const [activeSlidePush, setActiveSlidePush] = useState(0)
  const [activeSlide, setActiveSlide] = useState(0)

  const slider_action = getActionByType(
    allPushData,
    getCodeFromType('Slider de Imagenes Encabezado'),
  )
  const image_action = getActionByType(allPushData, getCodeFromType('Imagen Encabezado'))
  const video_action = getActionByType(allPushData, getCodeFromType('Video Encabezado'))

  function validateArrows() {
    if (slider_action.length > 0 || items?.length! > 1) {
      return true
    }
    return false
  }

  const settingsHero = {
    dots: validateArrows(),
    infinite: validateArrows(),
    afterChange: function (index: number) {
      setActiveSlide(index)
    },
    speed: 1000,
    fade: true,
    slidesToShow: 1,
    pauseOnHover: false,
    slidesToScroll: 1,
  }

  const settingsPush = {
    dots: validateArrows(),
    infinite: validateArrows(),
    afterChange: function (index: number) {
      setActiveSlidePush(index)
    },
    speed: 500,
    fade: true,
    slidesToShow: 1,
    pauseOnHover: false,

    slidesToScroll: 1,
  }

  const [sendTrackerEvent] = useSendTrackerEvent()

  const goTo = () => {
    if (video_action[0].url_destiny) {
      if (isBrowser) {
        window.open(
          video_action[0].url_destiny + video_action[0].text_utm,
          '_blank',
          'noopener,noreferrer',
        )
      }
      informCustomEvent('PUSH_' + currentPage?.id + '_' + '0' + '_' + video_action[0].id)
      sendTrackerEvent(
        getQueryEventTracker({
          page: currentPage!,
          action: video_action[0],
          type: 'PUSH',
          data_id: '0',
          url: location.href,
        }),
      )
    }
  }

  useEffect(() => {
    if (video_action.length > 0) {
      informCustomEvent('SHOW_' + currentPage?.id + '_' + '0' + '_' + video_action[0].id)
      sendTrackerEvent(
        getQueryEventTracker({
          page: currentPage!,
          action: video_action[0],
          type: 'SHOW',
          data_id: '0',
          url: location.href,
        }),
      )
    }
    if (image_action.length > 0) {
      informCustomEvent('SHOW_' + currentPage?.id + '_' + '0' + '_' + image_action[0].id)
      sendTrackerEvent(
        getQueryEventTracker({
          page: currentPage!,
          action: image_action[0],
          type: 'SHOW',
          data_id: '0',
          url: location.href,
        }),
      )
    }
    if (slider_action.length > 0) {
      informCustomEvent('SHOW_' + currentPage?.id + '_' + '0' + '_' + slider_action[0].id)
      sendTrackerEvent(
        getQueryEventTracker({
          page: currentPage!,
          action: slider_action[0],
          type: 'SHOW',
          data_id: '0',
          url: location.href,
        }),
      )
    }
    setClientHeight(document?.getElementById('header')?.clientHeight ?? 0)
  }, [loading])

  const Searcher = require(`@components/search/${searcherId ? searcherId : '7'}`)?.default

  const isDesktop = () => (screen.width < 992 ? false : true)

  const RenderPushImage = () => {
    return (
      <img
        // onClick={() => validateGoTo()}
        className={'image-push ' + (image_action.at(0)?.url_destiny && 'cursor-pointer')}
        src={image_action.at(0)?.files.at(0)?.file}
        alt=""
      />
    )
  }

  const RenderPushVideo = () => {
    return (
      <video
        style={{ zIndex: 21 }}
        className={'d-lg-block'}
        loop
        autoPlay
        muted
        // onClick={() => validateGoTo()}
      >
        <source
          src={
            isDesktop()
              ? video_action[0].files.find(
                  (video: { device: string }) => video.device === 'desktop',
                )?.file || video_action[0].files[0].file
              : video_action[0].files.find((video: { device: string }) => video.device === 'mobile')
                  ?.file ||
                video_action[0].files[0].file ||
                video_action[0].files.find(
                  (video: { device: string }) => video.device === 'desktop',
                )?.file ||
                video_action[0].files[0].file
          }
          type="video/mp4"
        />
      </video>
    )
  }

  const RenderPushSlider = () => {
    return (
      <Slider
        className="slider-hero"
        {...settingsPush}
        autoplay={slider_action.at(0).transition_time ? false : false}
        autoplaySpeed={slider_action.at(0).transition_time * 1000}
        ref={sliderRefPush}
      >
        {slider_action
          .at(0)
          ?.files.map(
            ({ file, url_destiny }: { file: string; url_destiny: string }, index: number) => (
              <div
                key={index + file}
                className="position-relative h-100"
              >
                <div className={`${url_destiny && 'cursor-pointer'}`}>
                  {opacityValue && opacityValue !== '0' ? (
                    <div
                      id="opacity-layer"
                      style={{
                        pointerEvents: 'none',
                        opacity:
                          opacityValue && opacityValue !== '0'
                            ? Number(opacityValue) !== 100
                              ? `0.${Number(opacityValue)}`
                              : 1
                            : 0,
                      }}
                    ></div>
                  ) : null}
                  <div className={'title-container'}>
                    {paragraph &&
                      paragraph.split('\n').map((paragraph, index) => (
                        <div>
                          <ElementHTML
                            children={paragraph || ''}
                            className={' d-none d-lg-block'}
                            style={{ color: titleHexa }}
                            elementType={titleElement || 'h1'}
                            key={index + '-h'}
                          />
                          <ElementHTML
                            children={paragraph || ''}
                            className={' d-block d-lg-none'}
                            style={{ color: titleHexa }}
                            elementType={titleElement || 'h1'}
                            key={index + '-p'}
                          />
                        </div>
                      ))}
                  </div>
                  <div
                    className="link"
                    onClick={() => validateGoTo()}
                  ></div>
                  {searcherId && (
                    <Searcher
                      global_data={global_data}
                      button={button}
                    />
                  )}
                  <img
                    src={file}
                    className="image-push"
                    alt=""
                  />
                </div>
              </div>
            ),
          )}
      </Slider>
    )
  }

  function scrollPage() {
    if (typeof window !== `undefined`) {
      var body = $('html, body')
      return body.stop().animate({ scrollTop: window.innerHeight }, 500, 'swing', function () {})
    }
  }

  const validateGoTo = () => {
    if (video_action.length > 0) {
      return goTo()
    } else if (image_action.length > 0) {
      return goToImage(image_action[0])
    } else if (slider_action.length > 0) {
      return goToImage(slider_action[0], activeSlidePush)
    }
    if (items?.length! > 0) {
      if (items?.[activeSlide]?.value) {
        return window?.open(items?.[activeSlide]?.value)
      }
    }
    return null
  }

  const checkPointer = () => {
    if (slider_action.length > 0) {
      if (slider_action[0].files[activeSlidePush].url_destiny) {
        return true
      }
      return false
    }
    if (items?.length! > 0) {
      if (items![activeSlide]?.value) {
        return true
      }
      return false
    }
  }

  const [delaytitle, setDelaytitle] = useState(false)

  const goToImage = (action: Action, index?: number) => {
    if (index !== undefined && action?.files[index].url_destiny) {
      window?.open(action?.files[index].url_destiny)
    } else if (action.url_destiny) {
      window?.open(action?.url_destiny)
    }
    informCustomEvent('PUSH_' + currentPage?.id + '_' + '0' + '_' + action.id)
    sendTrackerEvent(
      getQueryEventTracker({
        page: currentPage!,
        action: action,
        type: 'PUSH',
        data_id: '0',
        url: location.href,
      }),
    )
  }

  const [clientHeight, setClientHeight] = useState(0)
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
    setTimeout(() => {
      setDelaytitle(true)
    }, 1000)
  }, [])

  return (
    isMounted && (
      <div
        id="hero-main"
        style={{
          height: height
            ? screen.width < 992
              ? height?.mobile !== '0' && height?.mobile !== null
                ? height?.mobile + 'vh'
                : `calc(100vh - ${clientHeight}px)`
              : height?.desktop !== '0' && height?.desktop !== null
              ? height?.desktop + 'vh'
              : `calc(100vh - ${clientHeight}px)`
            : '',
        }}
        className={`banner-main g ${loading ? ' skeleton' : ''}${
          slider_action.length > 0 ? ' slider-hero' : ''
        } ${searcherId === '5' ? 'bottom-pro-searcher' : ''}
        `}
      >
        {/* //Slider imagenes */}
        {items?.length! > 0 && slider_action.length === 0 ? (
          <div className="slider-hero">
            <div className="position-absolute-content">
              {Searcher && (
                <Searcher
                  global_data={global_data}
                  button={button}
                />
              )}
            </div>
            <Slider
              {...settingsHero}
              autoplay={true}
              autoplaySpeed={4000}
              ref={sliderRefHero}
            >
              {items?.map(({ image, image_gatsby, image_mobile, title, paragraph }, index) => (
                <div
                  key={index}
                  className={
                    'position-relative content-slider ' + (checkPointer() && 'cursor-pointer')
                  }
                >
                  <div className="d-flex flex-column align-items-center justify-content-center">
                    {opacityValue && opacityValue !== '0' ? (
                      <div
                        id="opacity-layer"
                        style={{
                          pointerEvents: 'none',
                          opacity:
                            opacityValue && opacityValue !== '0'
                              ? Number(opacityValue) !== 100
                                ? `0.${Number(opacityValue)}`
                                : 1
                              : 0,
                        }}
                      ></div>
                    ) : null}
                    {title &&
                      title.split('\n').map((title_, index) => (
                        <>
                          <ElementHTML
                            children={title_ || ''}
                            className={' d-none d-lg-block title-element'}
                            style={{ color: titleHexa }}
                            elementType={titleElement || 'h1'}
                            key={index + '-h'}
                          />
                          <ElementHTML
                            children={title_ || ''}
                            className={' d-flex d-lg-none title-element'}
                            style={{ color: titleHexa }}
                            elementType={titleElement || 'h1'}
                            key={index + '-p'}
                          />
                        </>
                      ))}
                    {paragraph && (
                      <div className="mt-3 paragraph-element">
                        {paragraph.split('\n').map((paragraph_, index) => (
                          <>
                            <ElementHTML
                              children={paragraph_ || ''}
                              className={' m-0'}
                              style={{ color: titleHexa }}
                              elementType={'h5'}
                              key={index + '-p'}
                            />
                          </>
                        ))}
                      </div>
                    )}
                    {/* <div
                      className="link"
                      onClick={() => validateGoTo()}
                    ></div> */}
                    <Image
                      image={isDesktop() ? image_gatsby!! : null}
                      hrefImage={isDesktop() ? '' : image_mobile ? image_mobile : image}
                      className="image-push"
                      alt=""
                      objectFit="cover"
                    ></Image>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        ) : (
          ''
        )}
        {/* {validateArrows() && ( */}
        {false && (
          <div>
            <div className={'arrows-left onTop zindex-1'}>
              <div
                className="arrow"
                onClick={() =>
                  slider_action.length === 0
                    ? sliderRefHero.current.slickPrev()
                    : sliderRefPush.current.slickPrev()
                }
              >
                {' '}
                <i></i> <i></i>
              </div>
            </div>
            <div className={'arrows-right onTop zindex-1'}>
              <div
                className="arrow"
                onClick={() =>
                  slider_action.length === 0
                    ? sliderRefHero.current.slickNext()
                    : sliderRefPush.current.slickNext()
                }
              >
                {' '}
                <i></i> <i></i>{' '}
              </div>
            </div>
          </div>
        )}
      </div>
    )
  )
}

export default Hero_2
